import React from "react";
import * as PropTypes from "prop-types";
import { withStyles } from "@material-ui/core";
import classNames from "classnames";
import Button from "@material-ui/core/Button";
import styleConstants from "../../styleConstants";

const styles = {
  absoluteButton: {
    borderRight: `1px solid ${styleConstants.colors.gray4}`
  },
  container: {
    display: "flex",
    flexWrap: "nowrap"
  },
  button: {
    width: 70,
    backgroundColor: "white",
    fontSize: "0.625rem",
    fontWeight: styleConstants.fontWeights.book,
    color: styleConstants.colors.gray5,
    border: `1px solid ${styleConstants.colors.gray4}`,
    borderRadius: 0
  },
  relativeButton: {
    borderLeftWidth: 0
  },
  selected: {
    backgroundColor: styleConstants.colors.gray2,
    color: styleConstants.colors.gray6
  }
};

const Switch = props => (
  <form className={props.classes.container}>
    <div>
      <Button
        href={null}
        size="small"
        className={classNames(
          props.classes.button,
          props.buttonClassName,
          props.classes.absoluteButton,
          props.checked ? props.classes.selected : undefined
        )}
        onClick={() => {
          if (!props.checked) {
            props.onToggle();
          }
        }}
      >
        {props.onText}
      </Button>
      <Button
        href={null}
        size="small"
        className={classNames(
          props.classes.button,
          props.buttonClassName,
          props.classes.relativeButton,
          props.checked ? undefined : props.classes.selected
        )}
        onClick={() => {
          if (props.checked) {
            props.onToggle();
          }
        }}
      >
        {props.offText}
      </Button>
    </div>
  </form>
);

Switch.propTypes = {
  onText: PropTypes.string.isRequired,
  offText: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  buttonClassName: PropTypes.string,
  onToggle: PropTypes.func.isRequired
};

export default withStyles(styles)(Switch);
